import { IRawMatrix } from '../api/models/member/member.types';

export enum EPersonalityTypes {
  CHIVALROUS = 'CHIVALROUS',
  EGALITARIAN = 'EGALITARIAN',
  NEO_ROMANTIC = 'NEO_ROMANTIC',
  TRADITIONNALIST = 'TRADITIONNALIST',
}

export enum EApiPersonalityTypes {
  CONVENTIONAL_ROMANTIC = 'CONVENTIONAL_ROMANTIC',
  EQUALITY = 'EQUALITY',
  MODERN_ROMANTIC = 'MODERN_ROMANTIC',
  TRADITIONAL = 'TRADITIONAL',
}

export enum EVisionSections {
  LOVE_PERCEPTION = 'LOVE_PERCEPTION',
  FIDELITY = 'FIDELITY',
  ROUTINE = 'ROUTINE',
  SEXUALITY = 'SEXUALITY',
  FAMILY = 'FAMILY',
  EDUCATION = 'EDUCATION',
  RELIGION = 'RELIGION',
}

export enum EPersonalitySections {
  LOVE_NEEDS_INVEST = 'LOVE_NEEDS_INVEST',
  PERSONALITY_LONELINESS_VS_CONTACT = 'PERSONALITY_LONELINESS_VS_CONTACT',
  RELATION_WITH_OTHERS = 'RELATION_WITH_OTHERS',
  SOULMATES = 'SOULMATES',
  COMMUNICATION = 'COMMUNICATION',
  THINK = 'THINK',
  EMOTIONAL = 'EMOTIONAL',
}

export interface IPersonalityReportGraph {
  id: string;
  analysis: string[];
  emphasis: string[];
  matrices: IRawMatrix[];
}

export interface IPersonalityReport {
  id: string;
  type: string;
  attributes: {
    analysis: string[];
    emphasis: string[];
    graphes: IPersonalityReportGraph[];
  };
}

export interface IPersonalityReportTabProps {
  goToPrevTab?: () => void;
  goToNextTab?: () => void;
  graphs: IPersonalityReportGraph[];
  personalityType: EPersonalityTypes;
  shouldStartOnLastPage?: boolean;
}

export interface IMatchingVision {
  title: string;
  description: string;
}

export interface IPersonalityReportPageStructure {
  nbIntro: number;
  nbOutro?: number;
  nbGraphItems?: number;
}
